module.exports = __webpack_public_path__ + "static/media/HomeKCB.8cecc194.svg";